module.exports = "<div class=\"cancel-demo-body\">\r\n  <div class=\"cancel-demo-txt\">Are you sure you want to <br>cancel your demo?</div>\r\n  <div class=\"cancel-demo-btn\" (click)=\"cancel();\">Cancel Demo</div>\r\n  <!-- <div class=\"cancel-demo-btn\" (click)=\"reschedule()\">Reschedule Demo</div> -->\r\n  <div class=\"cancel-demo-btn white\" (click)=\"closeModal()\">Do Not Cancel</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/Components/desktop-cancel-demo/desktop-cancel-demo.component.html
// module id = ../../../../../src/app/Components/desktop-cancel-demo/desktop-cancel-demo.component.html
// module chunks = 1